
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Phone } from 'lucide-react';

interface EmergencyServicesProps {
  locationName: string;
  phone: string;
}

const EmergencyServices: React.FC<EmergencyServicesProps> = ({ locationName, phone }) => {
  const stormServices = [
    "24/7 emergency tarping and stabilization",
    "Insurance documentation through claims@CarolinaTrophy",
    "Rapid damage assessment using drone technology",
    "Priority scheduling for emergency repairs",
    "Direct insurance billing when possible"
  ];

  const responseFeatures = [
    "Average 3.8-hour response time for emergency tarping",
    "GPS-tracked emergency vehicles for rapid deployment",
    "Complete storm damage documentation for insurance",
    "Temporary stabilization and weatherproofing"
  ];

  return (
    <section className="mb-12">
      <h2 className="text-3xl font-bold mb-6 flex items-center">
        <Phone className="h-8 w-8 text-red-500 mr-3" />
        24/7 Emergency Services
      </h2>
      
      <Card>
        <CardContent className="pt-6">
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-xl font-bold mb-4">Storm Response</h3>
              <p className="mb-4">
                When severe weather strikes {locationName} and the Twin Counties, our emergency response team is ready with:
              </p>
              <ul className="space-y-2">
                {stormServices.map((service, index) => (
                  <li key={index}>• {service}</li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">Emergency Response</h3>
              <div className="bg-red-50 p-4 rounded-lg">
                <p className="font-bold text-red-800">Emergency Hotline: {phone}</p>
                <ul className="mt-2 space-y-1 text-red-700">
                  {responseFeatures.map((feature, index) => (
                    <li key={index}>• {feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default EmergencyServices;
